import apiService from '../../apiService';

const TEMPLATE_URL = 'crm';

const crmTemplateService = {
  async createCrmTemplate(payload) {
    try {
      const response = await apiService.post(`${TEMPLATE_URL}/store_template`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateCrmTemplate(id, payload) {
    try {
      const response = await apiService.post(`${TEMPLATE_URL}/update_template/${id}?_method=PUT`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getAllCrmTemplates(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`${TEMPLATE_URL}/templates${queryParams ? `?${queryParams}` : ''}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getCrmTemplate(id) {
    try {
      const response = await apiService.get(`${TEMPLATE_URL}/templates/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async previewCrmTemplate(id) {
    try {
      const response = await apiService.get(`${TEMPLATE_URL}/templates/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteCrmTemplate(id) {
    try {
      const response = await apiService.delete(`${TEMPLATE_URL}/templates/${id}`,);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

};

export default crmTemplateService;